import React, { useState, useEffect } from 'react';
import { convertValueToUSD } from '../../../../helpers/currency.helper';

const STYLES = {
  SPLITTING_RESULT_TEXT: 'text-action03 font-metricR text-[16px] text-center',
  SPLITTING_RESULT_TEXT_INPUT: 'min-w-[50px] max-w-[80px] text-center [&::-webkit-inner-spin-button]:appearance-none focus:outline-0',
};

interface IAmountInput {
  amount: number;
  maxAmount: number;
  name: string;
  onAmountChange: (amount: number, isManualBusinessAmount: boolean) => void;
}

export const AmountInput = (
  {
    amount,
    maxAmount,
    name,
    onAmountChange,
  }: IAmountInput,
) => {
  const [value, setValue] = useState<number>(0);
  const [isFocused, setIsFocused] = useState<boolean>(false);
  let inputType = 'text';
  if (isFocused) {
    inputType = 'number';
  }
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitizedValue = parseFloat(e.target.value ? e.target.value : '0');
    const isManualBusinessAmount = e.target.name === 'businessAmount';
    if (sanitizedValue >= 0 && sanitizedValue <= maxAmount) {
      setValue(sanitizedValue);
      onAmountChange(sanitizedValue, isManualBusinessAmount);
    }
  };

  useEffect(() => {
    setValue(amount);
  }, [amount]);
  return (
    <div className={STYLES.SPLITTING_RESULT_TEXT}>
      <input
        type={inputType}
        name={name}
        id={`amountInput_${name}`}
        data-testid={`amountInput_${name}`}
        className={STYLES.SPLITTING_RESULT_TEXT_INPUT}
        value={isFocused ? value.toString().replace(/^0+/, '') : convertValueToUSD(value, 2)}
        onChange={handleInputChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
    </div>
  );
};
